module.exports = __webpack_public_path__ + "img/index_05.1eedb0fb.jpg";